<template>
    <section id="offer" class="scroll-mt-24">
        <h3 class="text-lg font-semibold mb-6">{{ $t('Facility offer') }}</h3>
        <div class="prose-item-sm bg-gray-50 rounded-lg p-6 columns-1 md:columns-2 lg:columns-3">
            <template v-for="(property, key) in item?.properties" :key="key">
                <div class="break-inside-avoid-column mb-6">
                    <div class="font-bold">{{ property.label }}</div>
                    <ul class="space-x-2 my-0">
                        <template v-for="(item, key) in property.items" :key="key">
                            <li>
                                {{ item.label }}
                                <template v-if="item.type != 'boolean'">: {{ item.value }}</template>
                            </li>
                        </template>
                    </ul>
                </div>
            </template>

            <template v-for="(property, key) in item?.property?.properties" :key="key">
                <div class="break-inside-avoid-column mb-6">
                    <div class="font-bold">{{ property.label }}</div>
                    <ul class="space-x-2 my-0">
                        <template v-for="(item, key) in property.items" :key="key">
                            <li>
                                {{ item.label }}
                                <template v-if="item.type != 'boolean'">: {{ item.value }}</template>
                            </li>
                        </template>
                    </ul>
                </div>
            </template>
        </div>
    </section>
</template>

<script setup>
defineProps({
    item: {
        type: Object,
        required: true
    }
})
</script>
